import { createFileRoute } from "@tanstack/react-router";

import { SuppliersPage } from "../../../../features/purchasing/suppliers-page";

export const Route = createFileRoute("/_app/purchasing/suppliers/")({ component: SuppliersPage });
